import { useSocket as useSocketContext } from '../context/SocketContext';

export const useSocket = () => {
  const { socket, isConnected, emit, on, off } = useSocketContext();

  return {
    socket,
    connected: isConnected,
    emit,
    on,
    off,
  };
};
